import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class ScrapMetal extends DestroyableObstacle {
	static key = "ScrapMetal";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): ScrapMetal {
		const s = new ScrapMetal(deserializeXY(data.xy));
		s.restoreBaseFields(data);
		return s;
	}
}
